import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";



import {
  editDescription,
  editMediaSettings,
  editSignupBackgroundColor,
  uploadPhoto,
} from "./fetch";
import { signupOptionKeys } from "./keys";


export const useEditSignupBackgroundColor = ({
  signupID,
  backgroundColor,
  onSuccess,
}) => {
  return useMutation({
    mutationKey: signupOptionKeys.backgroundColor({
      signupID,
      backgroundColor,
    }),
    mutationFn: async ({ color, colorScheme }) => {
      return await editSignupBackgroundColor({ signupID, color, colorScheme });
    },
    onSuccess: (res) => {
      onSuccess && onSuccess(res);
    },
  });
};

export const useUploadPhoto = ({ onSuccess, onError }) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: signupOptionKeys.uploadPhoto(),
    mutationFn: async (formData, options) => {
      return await uploadPhoto(formData, options);
    },
    onSuccess: (res) => {
      onSuccess && onSuccess(res);
      queryClient.invalidateQueries(signupOptionKeys.uploadPhoto());
    },
    onError: (err) => {
      if (onError) onError(err);
    },
  });
};

export const useEditMediaSettings = ({ signupID, onSuccess }) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: signupOptionKeys.editMediaSettings({ signupID }),
    mutationFn: async (newMediaSettings) => {
      return await editMediaSettings({ signupID, newMediaSettings });
    },
    onSuccess: (res) => {
      onSuccess && onSuccess(res);
      queryClient.invalidateQueries(
        signupOptionKeys.editMediaSettings({ signupID })
      );
    },
  });
};

export const useEditDescription = ({ signupID, onSuccess }) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: signupOptionKeys.editDescription({ signupID }),
    mutationFn: async (description) => {
      return await editDescription({ signupID, description });
    },
    onSuccess: (res) => {
      onSuccess && onSuccess(res);
      queryClient.invalidateQueries(
        signupOptionKeys.editDescription({ signupID })
      );
    },
  });
};